<template #content>
    

    <Toolbar class="mb-2 bg-gray-100">
        <template #end>
            <div class="flex items-center gap-1">
                <Button icon="pi pi-search" label="Buscar" severity="sucess" size="small" @click="toggleBusca" />
                <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small" @click="loadData" />
            </div>
        </template>
    </Toolbar>

    <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
        scrollHeight="calc(100vh - 500px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
        @sort="onTableSort">

        <Column style="width: 100px" field="id" header="#" sortable></Column>
        <Column field="id_primario" header="ID Primario" sortable></Column>
        <Column field="id_secundario" header="ID Secundario" sortable></Column>
        <Column field="cliente" header="Cliente" sortable></Column>
        <Column field="site" header="Site/Localidade" sortable></Column>
        <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
            <template #body="{ data }">
                <Badge v-if="data.pendencias" :value="data.pendencias" severity="warn"></Badge>
                <Button icon="pi pi-pen-to-square" title="Atualizar" severity="info" size="small"
                    @click="openForm(data)" />
            </template>
        </Column>

        <template #empty>
            <div class="text-center text-gray-600">
                Nenhum registro encontrado
            </div>
        </template>
    </DataTable>

    <div class="flex justify-content-between flex-wrap">
        <div class="flex align-items-center justify-content-center">
            <div class="flex justify-end mt-2 text-sm text-gray-600">
                <span>{{ pagination.total }} registros</span>
            </div>

        </div>
        <div class="flex align-items-center justify-content-center">
            <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                @page="onPage">
            </Paginator>
        </div>
        <div class="flex align-items-center justify-content-center">
        </div>
    </div>

    <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
        <div class="w-full">
            <form @submit.prevent="onSubmitBusca">
                <div class="w-full">
                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText v-model="params.filter['contrato']" class="w-full" />
                            <label>Id Primário e Secundário</label>
                        </FloatLabel>
                    </div>

                    <div class="field mt-4">
                        <FloatLabel>
                            <InputText v-model="params.filter['site']" class="w-full" />
                            <label>Site/Localidade</label>
                        </FloatLabel>
                    </div>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                        class="flex align-items-center justify-content-center" />
                    <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                        class="flex align-items-center justify-content-center" @click="onClearBusca" />
                    <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                        class="flex align-items-center justify-content-center" @click="toggleBusca" />
                </div>
            </form>
        </div>
    </Popover>

</template>
<script>
import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Badge from 'primevue/badge';

import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import ScrollPanel from 'primevue/scrollpanel';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

import DataTable from 'primevue/datatable';
import Toolbar from 'primevue/toolbar';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';

import Popover from 'primevue/popover';

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Contrato from '@/service/contrato.js';

import LogForm from '@/components/LogForm.vue';

import Filter from '@/utils/Filter.js';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        DataTable,
        Paginator,
        Column,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        ScrollPanel,
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        InputGroup,
        InputGroupAddon,
        Toolbar,
        Badge,
        Popover,

        LogForm,
    },
    props: {
        provedor: {},
    },
    emits: ['onOpenContratoForm'],
    data() {
        return {
            isLoading: false,

            visibleLogForm: false,

            tabIndex: 0,

            lista: [],
            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        openForm(contrato) {
            this.$emit("onOpenContratoForm", contrato);
        },
        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        loadDataParams() {
            let params = [`filter[cot.provedor_id]=${this.provedor.id}`];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Contrato.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>
